import {Component, OnInit} from '@angular/core';
import {Constant} from "./common/constant";
import {TranslateService} from "@ngx-translate/core";
import {DataService} from "./common/service/data.service";
import {NavigationEnd, Router, ActivatedRoute} from "@angular/router";
import {DialogService} from "./common/service/dialog.service";
import {environment} from "../environments/environment";
import { UserService } from './common/service/user.service';
import { Dispatcher, GetInfoUser, AppQueries, StorePermission } from './state';
import { AppSettings } from 'src/app/app.settings';
import { Settings } from 'src/app/app.settings.model';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { Observable, Subscription } from 'rxjs';
import { EventManagerService } from './common/service/event-manager.service';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { NewOTPComponent } from 'src/app/common/components/otp/otp.component';
import { ProductService } from 'src/app/common/service/product.service';
import { UserProfile } from './common/models/users.model';
import { MaintainceService } from './main/services/maintaince.service';
import { DetailTradingFund } from './common/components/detail-trading-fund/detail-trading-fund';
import { DetailNewFund } from './common/components/detail-new-fund/detail-new-fund';
import { InvestorService } from './main/services/investor.service';
import { DetailIssuer } from './common/components/detail-issuer/detail-issuer';
import { ThemeService } from './layouts/theme.service';
import { ToastrService } from 'ngx-toastr';
/**
 * declare Jquery
 * */
declare let $: any;
declare let ga: any;
declare var require: any;
declare let SockJS, Stomp: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [AppSettings]
})
export class AppComponent implements OnInit{

  public Constant = Constant;
  public isShowLoading : boolean = true;
  public settings: Settings;
  public subscriptions?: Subscription[] = [];
  ignoreApi: any[] = [];
  otp: any;
  product: any;
  userProfile: UserProfile;
  online$: Observable<boolean>;
  isOffline : boolean = false;
  isConnectSocket : boolean = false;
  stompClient: any;
  minHeight: string = '1500px';
  theme: string = 'default';
  noLoadingApi: any[] = [];
  shortLoadingApi: any[] = [];
  constructor(
    private translate:TranslateService,
    private router:Router,
    private dialog:DialogService,
    private toast: ToastrService,
    private dispatcher: Dispatcher,
    public dataService:DataService,
    public userService: UserService,
    private appSettings: AppSettings,
    private eventManager: EventManagerService,
    private $localStorage: LocalStorageService, 
    private $sessionStorage: SessionStorageService,
    private productService: ProductService,
    private investorService: InvestorService,
    private themeService: ThemeService,
    private modalService: NgbModal,
    private appQueries: AppQueries,
    private maintainceService: MaintainceService,
    public route: ActivatedRoute) {
    this.settings = this.appSettings.settings;
  
    this.route.params.subscribe(params => {
      if (location.search.substring(0, 14) === '?fb_action_ids') {
        location.search = '';
      }
    });
    this.route.queryParams.subscribe(params => {
      if (params.utm_source === 'accesstrade' && params.aff_sid) {
        this.$localStorage.store('utm_source', params.utm_source);
        this.$localStorage.store('aff_sid', params.aff_sid);
      }
    });
  }

  ngOnInit() {
    this.changeTheme(this.$localStorage.retrieve('theme'));
    // this.online$ = Observable.merge(
    //   Observable.of(navigator.onLine),
    //   Observable.fromEvent(window, 'online').mapTo(true),
    //   Observable.fromEvent(window, 'offline').mapTo(false)
    // );
    this.translate.use('vi_VN');
    this.initSingleApis();
    this.initIgnorepis();
    this.initNoRetryApis();
    this.initApiNoLoading();
    this.initApiShortLoading();
    const token = this.$localStorage.retrieve('TOKEN') || this.$sessionStorage.retrieve('TOKEN');
    if (token) {
      this.dispatcher.fire(new GetInfoUser());
    }
    const permissions = this.$localStorage.retrieve('PERMISSION') || this.$sessionStorage.retrieve('PERMISSION');
    if (permissions) {
      this.dispatcher.fire(new StorePermission(permissions));
    }
    this.dataService.getDataCommon();
    let scriptId = 'google-analytics';
    this.subscriptions = [
      this.appQueries.userProfile$
      .subscribe((userProfile) => {
        this.userProfile = userProfile;
      }),
      this.eventManager.subscribe('Fmarket.httpError', (res) => {
        // console.log('API error: ', res.content);
        const messsage = res.content.error.message || res.content.error.detail;
        if (!this.ignoreError(res.content.url || '')) {
          const text = window.navigator.onLine ? 'Hiện tại chức năng đang được cập nhật' : 'Có sự cố về kết nối mạng. Vui lòng kiểm tra lại.';
          this.toast.error(messsage || this.translate.instant(text));
        }
      }),
      this.eventManager.subscribe('Fmarket.maintainHttpError', (res) => {
        // console.log('API error: ', res.content);
        const messsage = res.content.error.message || res.content.error.detail;
        if (!this.ignoreError(res.content.url || '')) {
          if (!window.navigator.onLine) {
            this.dialog.showNoConnectInternet();
          } else  {
            if (!(this.userProfile && this.userProfile.id)) {
              this.router.navigate(['/503']);
            } else {
              this.maintainceService.addAPI(messsage || res.content.message);
            }
          }
        }
      }),
      // this.eventManager.subscribe('Fmarket.error', (res) => {
      //   const text = window.navigator.onLine ? 'Hiện tại hệ thống đang gặp cập nhật. Vui lòng quay lại sau !' : 'Có sự cố về kết nối mạng. Vui lòng kiểm tra lại.';
      //   this.dialog.showError(res.content.messsage || this.translate.instant(text));
      // }),
      this.eventManager.subscribe('httpError-401', (res) => {
        this.modalService.dismissAll();
      }),
      this.eventManager.subscribe('detail-product', (res) => {
        this.detailProduct(res.content);
      }),
      this.eventManager.subscribe('open-otp', (res) => {
        this.openOTP(res.content);
      }),   
      this.eventManager.subscribe('show-spinner', (res) => {
        this.isShowLoading = true;
      }), 
      this.eventManager.subscribe('close-spinner', (res) => {
        this.isShowLoading = false;
      }),     
      this.eventManager.subscribe('connect-socket', (res) => {
        if (!this.isConnectSocket) {
          this.connectSocket();
        }
      }),
      this.eventManager.subscribe('copy-clipboard', (res) => {
        this.eventManager.broadcast({
          name: 'get-content-clipboard',
          content: {
            value: res.content.value
          }
        })
      }),
    ];
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.dataService.isLoading = false;
        sessionStorage.setItem(Constant.key_local_current_screen, event.url);
        this.dialog.destroy();
      }
    });
    if (environment.production) {
      this.router.errorHandler = (error)=>{
        if (navigator.onLine){
          location.reload()
        }else {
          this.dialog.showError(this.translate.instant('error.disconnect'));
          this.dataService.isLoading = false;
        }
      };
    }
    if (document.getElementById(scriptId)) {
      return;
    }
    $('body').on('click', (e) => {
      this.eventManager.broadcast({
        name: 'body-click',
        content: {
          event: e
        }
      })
    });

    $( window ).scroll((e) => {
      this.minHeight =  e.target.body.clientHeight > 1500 ? e.target.body.clientHeight + 'px' : '1500px';
    });
  }
  noticeOffline() {
    if (this.isOffline) {
      return;
    }
    this.isOffline = true;
    this.dialog.showNoConnectInternet();
  }
  public hideLoading() {
    return new Promise<boolean>(resolve => {
      setTimeout(() => {
        setTimeout(()=>{
          resolve(true);
          $('body').removeClass("modal-open");
          $('body').css('padding-right','0');
        },300)
      }, 300);
    })
  }
  changeTheme(theme) {
    theme = theme || 'default';
    this.theme = theme;
    this.$localStorage.store('theme', theme);
    this.themeService.changeTheme(theme);
  }
  openOTP(payload) {
    const otp: any = Object.assign({}, this.otp);
    payload = payload || {};
    const user = this.$localStorage.retrieve('USER_PROFILE') || {};
    const options: NgbModalOptions = {
        backdrop : 'static',
        keyboard : false
    };
    options.centered = true;
    options.windowClass  = 'otp-order-label';
    const modalRef = this.modalService.open(NewOTPComponent, options);
    const properties = payload.isReopen ? otp : payload;
    modalRef.componentInstance.phone = payload.phone || user.phone;
    Object.keys(properties || {}).forEach((key) => {
        modalRef.componentInstance[key] = properties[key] || {};
    });
    if (!payload.isReopen) {
        Object.keys(properties || {}).forEach((key) => {
            otp[key] = properties[key] || {};
        });
        otp.startTime = Date.now();
        otp.failTimes = 0;
        modalRef.componentInstance.startTime = otp.startTime;
    }
    this.otp = otp;
  }
  detailProduct(event) {
    if (!event) {
      return;
    }
    const id = event.productId || event.id;
    this.investorService.getProductById(id)
    .subscribe((result: any) => {
        this.product = this.productService.parse(result.data);
        switch (this.product.type) {
          case 'NEW_FUND':
            this.openProductModal(DetailNewFund);
          break;
          case 'TRADING_FUND':
            this.openProductModal(DetailTradingFund);
          break;
        }
    })
  }
  detailIssuer(event) {
    if (!event) {
      return;
    }
    const id = event.productId || event.id;
    this.investorService.getProductById(id)
    .subscribe((result: any) => {
      const product: any = this.productService.parse(result.data);
      const options: NgbModalOptions = {};
      options.centered = true;
      options.windowClass  = 'issuer-modal';
      const modalRef = this.modalService.open(DetailIssuer, options);
      modalRef.componentInstance.issuer = product.owner;
    })
  }
  openProductModal(component) {
    const options: NgbModalOptions = {};
    options.centered = true;
    options.windowClass  = 'detail-product-modal';
    const modalRef = this.modalService.open(component, options);
    modalRef.componentInstance.product = this.product;
  }
  connectSocket() {
    this.stompClient = null;

    var token = this.$localStorage.retrieve('TOKEN') || this.$sessionStorage.retrieve('TOKEN');
    var socket = new SockJS(environment.urlBackEnd + "/ws");
    this.stompClient = Stomp.over(socket);

    this.stompClient.connect(
      { Authorization: "Bearer " + token },
      this.onConnected.bind(this),
      onError
    );
    function onError(error) {
      console.log("Could not connect to WebSocket server. Please refresh this page to try again!");
    }
  }
  onConnected() {
    // Subscribe to the Public Topic
    this.stompClient.subscribe("/topic/progress", this.onMessageReceivedSocket.bind(this));
  }
  onMessageReceivedSocket(payload) {
    console.log(payload);
    var message = JSON.parse(payload.body);
    console.log(message);
    this.eventManager.broadcast({
      name: 'message-socket',
      content: {
        message
      }
    })
  }
  initSingleApis() {
    const singleAPIs = {};
    singleAPIs[Constant.api_approve_profile] = 0;
    singleAPIs[Constant.api_accept_profile] = 0;
    singleAPIs[Constant.api_cancel_profile] = 0;
    singleAPIs[Constant.api_count_list_register_trade] = 0;
    singleAPIs[Constant.api_count_pending_order] = 0;
    singleAPIs[Constant.api_payment_interest_noproduct] = 0;
    singleAPIs[Constant.api_add_agent_into_issuer] = 0;

    singleAPIs[Constant.api_change_request_profile_approve] = 0;
    singleAPIs[Constant.api_change_request_profile_reject] = 0;
    singleAPIs[Constant.api_profile_reject] = 0;
    singleAPIs[Constant.api_agent_register_sip_on_vsd] = 0;
    singleAPIs[Constant.api_agent_product_approve] = 0;
    singleAPIs[Constant.api_agent_product_approve_all] = 0;
    singleAPIs[Constant.api_agent_product_cancel_order] = 0;
    singleAPIs[Constant.api_agent_approve_sign_document_update_profile] = 0;

    singleAPIs[Constant.api_auth_sign_in] = 0;
    singleAPIs[Constant.api_auth_sign_in_confirm] = 0;
    singleAPIs[Constant.api_auth_sign_up] = 0;
    singleAPIs[Constant.api_auth_forgot_pass] = 0;
    singleAPIs[Constant.api_user_change_pass] = 0;
    singleAPIs[Constant.api_import_transaction] = 0;
    singleAPIs[Constant.api_check_approve_status] = 0;
    singleAPIs[Constant.api_common] = 0;
    singleAPIs['/investors/esign/sign/create'] = 0;
    singleAPIs['/investors/esign/sign/confirm'] = 0;
    singleAPIs['/robo-advisor/process'] = 0;
    singleAPIs['/export'] = 0;
    sessionStorage.setItem('singleAPIs', JSON.stringify(singleAPIs));
  }
  initIgnorepis() {
    this.ignoreApi = [
      Constant.api_get_change_profiles_export,
      Constant.api_agent_register_sip_export,
      Constant.api_agent_transaction_detail_export,
      Constant.api_agent_transaction_detail_export_vsd,
      Constant.api_agent_transaction_detail_export_sr45_46,
      Constant.api_get_profiles_export,
      Constant.api_get_approve_profiles_export,
      Constant.api_get_pending_profiles_vsd_export,
      Constant.api_export_list_investor,
      Constant.api_get_profiles_export,
      Constant.api_get_approve_profiles_export,
      Constant.api_get_pending_profiles_vsd_export,
      Constant.api_get_approve_profiles_export,
      Constant.api_issuer_export_transaction_history,
      Constant.api_agent_export_transaction_history,
      Constant.api_agent_transaction_detail_export_sip_hsbc,
      // uplo reconlied
      Constant.api_get_export_hsbcAgent,
      Constant.api_get_export_hsbc_balance ,
      Constant.api_get_export_upload_r44 ,
      Constant.api_get_export_hsbc_upload ,
      Constant.api_get_export_upload_reconlied ,
      Constant.api_get_export_vsd_upload ,

      '/users/profile/step-3/confirm'
    ];
  }
  ignoreError(url) {
    return this.ignoreApi.some((api) => url.includes(api));
  }
  initNoRetryApis() {
    const noRetryAPIs = [
      Constant.api_get_export_upload_r44,
      Constant.api_get_export_hsbc_upload,
      Constant.api_get_export_upload_reconlied,
      Constant.api_get_export_vsd_upload,
      Constant.api_get_export_hsbcAgent,
      Constant.api_get_export_hsbc_balance,
      Constant.api_get_export_product_vsd
    ];
    sessionStorage.setItem('noRetryAPIs', JSON.stringify(noRetryAPIs));
  }
  initApiNoLoading() {
    this.noLoadingApi = [
      { noProgress: true, url: 'vi_VN.json'},
      { noProgress: true, url: Constant.api_user_profile, method: "GET" },
      { noProgress: true, url: Constant.api_agent_order_accept_all_summary, method: "GET" },
      { noProgress: true, url: Constant.api_agent_order_approve_all_summary, method: "GET" },
      { noProgress: true, url: Constant.api_count_list_kyc_priority, method: "GET" },
      { noProgress: true, url: Constant.api_count_list_register_trade, method: "GET" },
      { noProgress: true, url: Constant.api_count_list_change_request, method: "GET" },
      { noProgress: true, url: Constant.api_count_pending_order, method: "GET" },
      { noProgress: true, url: Constant.api_count_register_sip, method: "GET" },
      { noProgress: true, url: Constant.api_count_priority_kyc, method: "GET" },
      { noProgress: true, url: Constant.api_agent_count_ekyc_manual_list, method: "GET" },
      { noProgress: true, url: Constant.api_common_agent_issuer },
      { url: Constant.api_user_profile, method: "GET" },
      { url: Constant.api_get_pending_profiles }, 
      { url: Constant.api_get_approve_profiles }, 
      { url: Constant.api_get_document_survey_ipo }, 
      { url: Constant.api_get_issuer_agent }, 
      { url: Constant.api_change_request_profile_filter }, 
      { url: Constant.api_profile_reject },
      { url: Constant.api_agent_orders }, 
      { url: Constant.api_agent_transaction_detail },
      { url: Constant.api_agent_register_sip },
      { url: Constant.api_agent_register_sip },
      { url: Constant.api_agent_statistic },
      { url: Constant.api_agents_list },
      { url: Constant.api_agent_name_orders },
      { url: Constant.api_agent_transaction_history }, 
      { url: Constant.api_agent_ekyc_log_list }, 
      { url: Constant.api_agent_ekyc_manual_list }, 
      { url: Constant.api_agent_list_sign_document_update_profile },
      { url: Constant.api_get_investment_profile_approved },
      { url: Constant.api_get_investor_profile_pending }, 
      { url: Constant.api_investors_list },
      { url: Constant.api_asset_report },
      { url: Constant.api_agent_investor_change_name_list },
      { url: Constant.api_agent_order_list },
      { url: Constant.api_agent_sip_register_list },
      { url: Constant.api_change_request_profile_filter },
      { url: Constant.api_agent_query_vsd_reconcile },
      { url: Constant.api_agent_query_change_profile },
      { url: Constant.api_get_statistic_gold_transaction },
      { url: Constant.api_get_calculate_fee_issuer },
    ];
    sessionStorage.setItem("noLoadingAPIs", JSON.stringify(this.noLoadingApi));
  }
  initApiShortLoading() {
    this.shortLoadingApi = [
      { url: Constant.api_user_profile, method: "GET" },
    ];
    sessionStorage.setItem("shortLoadingAPIs", JSON.stringify(this.shortLoadingApi));
  }
}
